export const RETAILER_OPTIONS = [
  { id: "all", label: "All" },
  { id: "morrison", label: "Morrisons" },
  { id: "asda", label: "Asda" },
  { id: "tesco", label: "Tesco" },
  { id: "sainsbury", label: "Sainsbury's" },
];

export const PRICE_MODE_OPTIONS = [
  { id: "base", label: "Base Price" },
  { id: "offer_loyalty", label: "Offer + Loyalty" },
];

export const RETAIL_KEYS = new Set(["tesco", "asda", "morrison", "sainsbury"]);

export const PLATFORM_LABELS = {
  tesco: "Tesco",
  asda: "Asda",
  morrison: "Morrisons",
  sainsbury: "Sainsbury's",
};

export function normalizeStoreKey(platform) {
  const p = String(platform || "").trim().toLowerCase();
  if (!p) return "";
  if (p.includes("tesco")) return "tesco";
  if (p.includes("asda")) return "asda";
  if (p.includes("morris")) return "morrison";
  if (p.includes("sains")) return "sainsbury";
  return "";
}

export function getCatalogFilterModes(retailer, priceMode) {
  const isOfferMode = priceMode === "offer_loyalty";
  const isFeaturesCompareMode = retailer === "all" && !isOfferMode;
  const isFeaturesOfferCompareMode = retailer === "all" && isOfferMode;
  const isPlatformBaseMode = retailer !== "all" && !isOfferMode;
  const isPlatformOfferMode = retailer !== "all" && isOfferMode;

  return {
    isOfferMode,
    isFeaturesCompareMode,
    isFeaturesOfferCompareMode,
    isPlatformBaseMode,
    isPlatformOfferMode,
  };
}
